import { z } from "zod";

export const ALPHANUMERIC_REGEX_WITH_ACCENTS = /^[a-zA-Z0-9\-_]+$/;
export const ALPHANUMERIC_ERROR_MESSAGE_WITH_ACCENTS = "Solo se permiten caracteres alfanuméricos";

export const createTemplateSchema = z.object({
    name: z.string().min(1, { message: "Debes ingresar un nombre" }).regex(ALPHANUMERIC_REGEX_WITH_ACCENTS, { message: ALPHANUMERIC_ERROR_MESSAGE_WITH_ACCENTS }),
    brand: z.string().min(1, { message: "Debes seleccionar una marca" }),
    format: z.string().min(1, { message: "Debes seleccionar un formato" }),
    type: z.string().min(1, { message: "Debes seleccionar un tipo" }),
});

export const updateTemplateSchema = z.object({
    name: z.string().min(1, { message: "Debes ingresar un nombre" }).regex(ALPHANUMERIC_REGEX_WITH_ACCENTS, { message: ALPHANUMERIC_ERROR_MESSAGE_WITH_ACCENTS }),
    brand: z.string().min(1, { message: "Debes seleccionar una marca" }),
    format: z.string().min(1, { message: "Debes seleccionar un formato" }),
    type: z.string().min(1, { message: "Debes seleccionar un tipo" }),
    created_at: z.string().optional(),
});